"use client";

import CheckSvgIcon from "@/shared/icons/CheckSvgIcon";
import ChevronDownSvgIcon from "@/shared/icons/ChevronDownSvgIcon";
import { City } from "@/types/city";
import { Icon, Portal, Select, Stack, Text, createListCollection, useSelectContext } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { useSearchParams, useRouter } from "next/navigation";
import { useMemo, useState } from "react";

export function StoreSort({ cities = [] }: { cities?: City[] }) {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const router = useRouter();

  // Читаем выбранный город из query-параметра
  const initialValue = searchParams.get("city") || "default";
  const [selectedCity, setSelectedCity] = useState(initialValue);

  function handleChange(value: string) {
    setSelectedCity(value);

    // Обновляем URL без перезагрузки страницы
    const params = new URLSearchParams(searchParams.toString());
    if (value === "default") {
      params.delete("city");
    } else {
      params.set("city", value);
    }

    router.replace(`${window.location.pathname}?${params.toString()}`);
  }

  const sorts = useMemo(
    () =>
      createListCollection({
        items: [
          { label: t("all"), value: "default" },
          ...(cities.map(city => ({ label: city.name, value: city.slug })) ?? []),
        ],
      }),
    [cities, t]
  );

  const SelectTrigger = () => {
    const select = useSelectContext();
    const items = select.selectedItems as any[];
    return (
      <Stack
        direction="row"
        align="center"
        gap="8px"
        cursor={"pointer"}
        {...(select.getTriggerProps() as any)}
      >
        <Text textStyle="medium16" color="#9E9F9D">
          {t("select_city")}:
        </Text>
        <Text textStyle="medium16">
          {select.hasSelectedItems ? items[0].label : t("select_value")}
        </Text>
        <Icon as={ChevronDownSvgIcon} boxSize={5} color="text.secondary" />
      </Stack>
    );
  };

  return (
    <Select.Root
      collection={sorts}
      variant={undefined}
      value={[selectedCity]}
      onValueChange={(item) => handleChange(item.value[0])}
      w={"auto"}
      my={4}
    >
      <Select.HiddenSelect />
      <Select.Control>
        <SelectTrigger />
      </Select.Control>

      <Portal>
        <Select.Positioner>
          <Select.Content maxWidth={'300px'} borderRadius={"none"}>
            {sorts.items.map((s) => (
              <Select.Item
                item={s}
                key={s.value}
                textStyle="medium16"
                borderRadius={"none"}
                padding="8px 16px"
              >
                {s.label}

                <Select.ItemIndicator>
                  <Icon color="brand">
                    <CheckSvgIcon />
                  </Icon>
                </Select.ItemIndicator>
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>
  );
}
